import { action, observable } from 'mobx';
import UnderLyingEnum from '@/@enums/UnderLyingEnum';
import { UpDownThemeEnum } from '@/@enums/Color';
import { AmountUnitEnum, Unit } from '@/@enums/Unit';

export default class Ui {
  @observable theme: Theme;

  @observable isShowSetting: boolean;

  @observable unit: Unit; // 用于交易界面
  @observable amountUnit: Unit; // 用于交易界面

  @observable uBasedUnit: Unit; // 用于Record菜单

  @observable coinBasedUnit: Unit; // 用于Record菜单

  @observable isConfirmAgain: boolean;

  @observable upDownColor: number;

  @observable resetLayoutsCounter: number;

  @observable upDownTheme: UpDownThemeEnum;

  @observable showRegister: boolean = false; // 控制 Register 弹窗显示状态
  @observable registerType: string = ''; //注册类型
  @observable registerValue: string = ''; // 注册账号
  @observable registerInviteCode: string = ''; // 注册邀请码

  @observable showLogin: boolean = false; // 控制 Login 弹窗显示状态

  @observable showFindPwd: boolean = false; // 控制 findpwd 弹窗显示状态

  constructor() {
    this.theme = 'Dark';
    this.isShowSetting = false;
    const storedConfirm = localStorage.getItem('isConfirmAgain');
    this.isConfirmAgain = storedConfirm === 'true';
    this.upDownColor = 1;
    this.unit = 'COIN';
    this.uBasedUnit = 'COIN';
    this.amountUnit = 'COIN'; // 下单数量单位
    this.coinBasedUnit = 'COIN';
    const storedUpDown = localStorage.getItem('upDownTheme') as UpDownThemeEnum | null;
    this.upDownTheme = storedUpDown && Object.values(UpDownThemeEnum).includes(storedUpDown)
      ? storedUpDown
      : UpDownThemeEnum.greenUpRedDown;
    this.resetLayoutsCounter = 0;
  }

  @action.bound
  showRegisterModal(params: { type?: string; registerValue?: string; inviteCode?: string } = {}) {
    this.showRegister = true;
    const { type, registerValue, inviteCode } = params;
    this.registerType = type ? type : '';
    this.registerValue = registerValue ? registerValue : '';
    this.registerInviteCode = inviteCode ? inviteCode : '';
  }

  @action.bound
  hideRegisterModal() {
    this.showRegister = false;
    this.registerType = '';
    this.registerValue = '';
    this.registerInviteCode = '';
  }

  @action.bound
  hideLoginModal() {
    this.showLogin = false;
  }

  @action.bound
  showFindPwdModal() {
    this.showFindPwd = true;
  }

  @action.bound
  hideFindPwdModal() {
    this.showFindPwd = false;
  }

  @action.bound
  showLoginModal() {
    this.showLogin = true;
  }

  @action.bound
  setTheme(data: Theme) {
    this.theme = data;
    localStorage.setItem('lvbitTheme', data);
  }

  // 涨跌颜色
  @action.bound
  setUpDownTheme(data: UpDownThemeEnum) {
    this.upDownTheme = data;
    localStorage.setItem('upDownTheme', data);
  }

  @action.bound
  setIsShowSetting(data: boolean) {
    this.isShowSetting = data;
  }

  @action.bound
  setUBasedUnit(data: Unit) {
    const result = data;
    localStorage.setItem('uBasedUnit', result);
    this.uBasedUnit = result;
  }

  @action.bound
  setCoinBasedUnit(data: Unit) {
    const result = data
    localStorage.setItem('coinBasedUnit', result);
    this.coinBasedUnit = result;
  }

  @action.bound
  setUnit(data: Unit, underlyingType: UnderLyingEnum) {
    const result = data;
    this.unit = result;
    if (underlyingType === UnderLyingEnum.U_BASED) {
      this.setUBasedUnit(result);
    } else {
      this.setCoinBasedUnit(result);
    }
  }

  @action.bound
  setIsConfirmAgain(data: boolean) {
    this.isConfirmAgain = data;
    localStorage.setItem('isConfirmAgain', String(data));
  }

  @action.bound
  resetLayouts() {
    this.resetLayoutsCounter++;
  }
}
